import { __assign, __extends, __spreadArrays } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { isPromise } from '../../common/index';
import { Button, RISK_BAD_UX_DISABLE_TOOLTIP } from '../../new-libby';
import { Popover, Icon } from '../../primitives';
import { FloaterMenu, MenuItem } from '../floater-menu/floater-menu';
import { buttonDd } from '../../icons';
import { classNames } from '@wix/answers-lib';
import { isFeatureEnabled } from '@wix/answers-experiments';
export var compactButtonGroupKey = 'compact-button-group';
var CompactButtonGroup = /** @class */ (function (_super) {
    __extends(CompactButtonGroup, _super);
    function CompactButtonGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            menuOpen: false,
            isLoading: false
        };
        _this.openMenu = function () {
            _this.setState({ menuOpen: true });
        };
        _this.closeMenu = function () {
            _this.setState({ menuOpen: false });
        };
        _this.startLoading = function () { return _this.setState({ isLoading: true }); };
        _this.stopLoading = function () { return _this.setState({ isLoading: false }); };
        _this.createOnAction = function (action) { return function () {
            var res = action();
            _this.closeMenu();
            if (isPromise(res)) {
                _this.startLoading();
                res.then(_this.stopLoading, _this.stopLoading);
            }
        }; };
        _this.menuItemTypeToButtonIntent = function (buttonIntent) {
            switch (buttonIntent) {
                case 'danger':
                    return 'danger';
                case 'positive':
                    return 'positive';
                default:
                    return 'neutral';
            }
        };
        _this.renderMenuItems = function () {
            return __spreadArrays([_this.props.primaryAction], (_this.props.additionalActions || [])).map(function (action, idx) {
                return (React.createElement(MenuItem, { onSelect: _this.createOnAction(action.onClick), key: idx, type: action.intent, disabled: action.disabled, className: action.className }, action.children));
            });
        };
        _this.renderMenu = function () {
            return (React.createElement(FloaterMenu, null, _this.renderMenuItems()));
        };
        return _this;
    }
    CompactButtonGroup.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var cn = namespacedClassnames(compactButtonGroupKey, props.className, { secondary: !!props.buttonType });
        var primaryActionIntent = this.props.intent || this.menuItemTypeToButtonIntent(props.primaryAction.intent);
        var primaryDisabled = props.disabled ? props.disabled : props.primaryAction.disabled;
        var additionalDisabled = state.isLoading || props.disabled ? RISK_BAD_UX_DISABLE_TOOLTIP : undefined;
        var hasMenu = isFeatureEnabled('CompactButtonGroupMenu') ? props.additionalActions.length > 0 : true;
        var maybeMenuButton = hasMenu ?
            React.createElement(Popover, { body: this.renderMenu(), isOpen: state.menuOpen, onOuterAction: this.closeMenu, bringToFront: props.bringToFront },
                React.createElement(Button, { className: 'open-menu-button', onClick: this.openMenu, disabled: additionalDisabled, intent: primaryActionIntent, type: props.buttonType ? props.buttonType : 'primary' },
                    React.createElement(Icon, { icon: buttonDd })))
            : null;
        return (React.createElement("div", { className: cn },
            React.createElement(Button, __assign({}, props.primaryAction, { disabled: primaryDisabled, intent: primaryActionIntent, onClick: this.createOnAction(props.primaryAction.onClick), className: classNames('primary-button', { 'has-menu': hasMenu }), forceLoading: state.isLoading, type: props.buttonType ? props.buttonType : 'primary' })),
            maybeMenuButton));
    };
    return CompactButtonGroup;
}(React.PureComponent));
export { CompactButtonGroup };
//# sourceMappingURL=index.js.map